import { Underline } from "@tiptap/extension-underline"
import { TEXT_COLOR_MAP } from "../../util/colors"
import { htmlMarkTokenizer, parseHtmlMark, renderHtmlMark } from "../../util/markdown-html-mark"

// Cp mod: Add an optional `color` attribute that sets the underline's
// text-decoration color (still rendered on a <u> element). Modeled on the base
// Highlight extension's "multicolor" feature, but always enabled.
export const UnderlineContentExtension = Underline.extend({
  addAttributes() {
    return {
      ...(this.parent?.() ?? {}),
      color: {
        default: null,
        renderHTML: (attributes) => {
          if (!attributes.color) {
            return {}
          }

          return {
            "data-color": attributes.color,
            style: `text-decoration-color: ${attributes.color}`,
          }
        },
        parseHTML: (element) =>
          element.getAttribute("data-color") || element.style.textDecorationColor,
      },
    }
  },

  markdownTokenName: "underline",
  markdownTokenizer: htmlMarkTokenizer("underline", "u"),
  renderMarkdown: (node, helpers) => renderHtmlMark(node, helpers, "u", TEXT_COLOR_MAP),
  parseMarkdown: (token, helpers) => parseHtmlMark(token, helpers, "underline", TEXT_COLOR_MAP),
})
